import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  // If the consumer passes a custom background (bg-*), don't apply the default white background.
  const hasCustomBg = /\bbg-[\w-]+/.test(className);
  const baseBg = hasCustomBg ? '' : 'bg-white';
  // Same for padding — if a custom padding (p-*, px-*, py-*) or p-0 is supplied, skip the default.
  const hasCustomPadding = /\bp[xytrbl]?-[\w-]+/.test(className);
  const basePadding = hasCustomPadding ? '' : 'p-6';
  return <div className={`${baseBg} rounded-lg border border-gray-border ${basePadding} ${hover ? 'hover:shadow-lg hover:-translate-y-1 transition-all duration-300' : ''} ${className}`} data-id="element-371">
      {children}
    </div>;
}